import { getDefaultClient } from '@arcubase/client-ts'

export const clientFetchAdapter = {
  get: (url: string, data?: any, config?: any) => getDefaultClient().get(url, data, config),
  post: (url: string, data?: any, config?: any) => getDefaultClient().post(url, data, config),
  put: (url: string, data?: any, config?: any) => getDefaultClient().put(url, data, config),
  delete: (url: string, data?: any, config?: any) => getDefaultClient().delete(url, data, config),
}

export default clientFetchAdapter
